import { render, staticRenderFns } from "./ledger_detail.vue?vue&type=template&id=244ffa2c&scoped=true&"
import script from "./ledger_detail.vue?vue&type=script&lang=js&"
export * from "./ledger_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ffa2c",
  null
  
)

export default component.exports